import React from 'react';
import {Gateway} from 'react-gateway';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
var createNotificationDialog = function(options, onClose) {
  options = options || {};
  var actions = [
    <RaisedButton
      label="OK"
      primary={true}
      onClick={onClose}
    />,
  ];
  return (
    <Gateway into="notification-modal">
      <Dialog
        title={options.title || 'Confirmation'}
        actions={actions}
        modal={true}
        open={true}
      >
        {options.content || 'Are you sure?'}
      </Dialog>
    </Gateway>
  )
}

export default createNotificationDialog;



/** WEBPACK FOOTER **
 ** ./src/components/Modal/createNotificationDialog.js
 **/